export default __webpack_public_path__ + "static/media/Path 86.12303277.svg";